import CRUDService from "./geral/CRUDService";

export default class AcheService extends CRUDService{
    constructor() {
        super("ache");
    }
}